import { takeLatest, call, put } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import {
  getWalletBalanceApi,
  getWalletLedgerApi,
  estimateWalletCostApi,
} from '../../api/apiLists/walletApi';
import {
  fetchWalletBalanceRequest,
  fetchWalletBalanceSuccess,
  fetchWalletBalanceFailure,
  fetchWalletLedgerRequest,
  fetchWalletLedgerSuccess,
  fetchWalletLedgerFailure,
  estimateWalletCostRequest,
  estimateWalletCostSuccess,
  estimateWalletCostFailure,
} from '../walletSlice';

export function* handleFetchWalletBalance() {
  try {
    yield put(fetchWalletBalanceRequest());
    const res = yield call(callWithAuth, getWalletBalanceApi, {});
    if (res.status) {
      yield put(fetchWalletBalanceSuccess(res.data));
    } else {
      yield put(fetchWalletBalanceFailure(res.errMsg));
    }
  } catch (error) {
    yield put(fetchWalletBalanceFailure(error.message));
  }
}

export function* handleFetchWalletLedger() {
  try {
    yield put(fetchWalletLedgerRequest());
    const res = yield call(callWithAuth, getWalletLedgerApi, {});
    if (res.status) {
      yield put(fetchWalletLedgerSuccess(res.data));
    } else {
      yield put(fetchWalletLedgerFailure(res.errMsg));
    }
  } catch (error) {
    yield put(fetchWalletLedgerFailure(error.message));
  }
}

export function* handleEstimateWalletCost(action) {
  try {
    const payload = action.payload || {};
    if (!Array.isArray(payload.campaignBreakdown) || payload.campaignBreakdown.length === 0) {
      yield put(estimateWalletCostFailure('campaignBreakdown is required.'));
      return;
    }

    yield put(estimateWalletCostRequest());
    const res = yield call(callWithAuth, estimateWalletCostApi, payload);
    if (res.status) {
      yield put(estimateWalletCostSuccess(res.data));
    } else {
      yield put(estimateWalletCostFailure(res.errMsg));
    }
  } catch (error) {
    yield put(estimateWalletCostFailure(error.message));
  }
}

export default function* walletSaga() {
  yield takeLatest('FETCH_WALLET_BALANCE', handleFetchWalletBalance);
  yield takeLatest('FETCH_WALLET_LEDGER', handleFetchWalletLedger);
  yield takeLatest('ESTIMATE_WALLET_COST', handleEstimateWalletCost);
}
